import styled from 'styled-components'

export const ContainerOfColumns = styled.div`
`

export const ColumnsList = styled.ul`
  overflow-y: auto;
  overflow-x: hidden;
  max-height: 500px;
  margin: 0;
  list-style: none;
  padding: .7rem;
  display: flex;
  flex-direction: column;
  gap: .7rem;
  background-color: #F4F4F4;
  border-radius: .7rem;
`

export const ColumnLI = styled.li`
  background-color: #fff;
  padding: 14px 16px;
  border-radius: .5rem;
  border: 1px solid #EBEBEB;
  cursor: pointer;
  user-select: none;
  display: flex;
  align-items: center;
  gap: 16px;
`

export const ColumnInfoDiv = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  flex: 1;
`

export const DropdownContainer = styled.div`
  position: relative;
  width: 5rem;
`

export const SelectDiv = styled.div<{disabled?: boolean}>`
  background-color: ${({disabled}) => disabled ? '#DCDCDC' : '#F4F4F4'};
  position: relative;
  padding: 8px 16px;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 400;
  border: 1px solid #EBEBEB;
  cursor: ${({disabled}) => disabled ? 'default' : 'pointer'};
  display: flex;
  align-items: center;
  justify-content: center;

  &:hover {
    border-color: #0090D3;
  }

  &:focus {
    border-color: #0090D3;
    box-shadow: 0 0 0 2px rgba(0, 144, 211, 0.2);
  }
`

export const ColumnName = styled.div`
  font-family: "Inter", Helvetica;
  font-size: 14px;
  font-weight: 700;
  color: #303030;
  line-height: 150%;
`

export const ColumnDesc = styled.div`
  font-family: "Inter", Helvetica;
  font-size: 12px;
  font-weight: 400;
  color: #696969;
  line-height: 150%;
`

export const Dropdown = styled.div`
  position: absolute;
  top: calc(100% + 2px);
  overflow-x: hidden;
  left: 0;
  background-color: #fff;
  border: 1px solid #EBEBEB;
  border-radius: 8px;
  z-index: 1;
  width: 100%;
`

export const DropdownItem = styled.div`
  padding: 8px 16px;
  font-size: 12px;
  font-weight: 400;
  text-align: center;
  color: #303030;
  cursor: pointer;
  background-color: #fff;
  border-bottom: 1px solid #EBEBEB;
  width: 100%;
  &:hover {
    background-color: #F4F4F4;
  }
`